
import cmxSDK from '../services/cmx-sdk';
import { setLanguageBundle } from '@nackle/intl-tools';
/*******************************************************************************
 * Initial state
 */
const initialState = {
    loading: false
};

/*******************************************************************************
 * Non-async action types
 */
const LOADING_START = 'loading/start';
const LOADING_END   = 'loading/end';

/*******************************************************************************
 * Reducer
 */
export default function appReducer( state = initialState, action ) {
    switch ( action.type ) {
        case LOADING_START: {
            return {
                ...state,
                loading: true
            };
        }
        case LOADING_END: {
            return {
                ...state,
                loading: false
            };
        }

        default:
            return state;
    }
}

/*******************************************************************************
 * Action creators
 */
export function getStrings( locale ) {

    return ( dispatch ) => {
        return cmxSDK().getBundle( locale )
            .then( bundle => {
                setLanguageBundle( locale, bundle.bundles[ locale ] );
                dispatch( endLoading() );
            } ).catch( error => {
                dispatch( endLoading() );
            } );


    };
}
export function startLoading( ) {
    return {
        type: LOADING_START
    };
}
export function endLoading( ) {
    return {
        type: LOADING_END
    };
}
